export default "__VITE_ASSET__CG4xPDDG__"